module.exports = __webpack_public_path__ + "static/media/ico-instagram.5395e93c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-instagram.svg
// module id = 163
// module chunks = 0